// These are the templates available for nudging patients, organized by language.
export const templateMessages: {
  [language: string]: { template: string }[];
} = {
  en: [
    { template: "chat_ready" },
    { template: "nurse_location_assistance_v3" },
    { template: "flagged_support_checkin" },
    { template: "test_result_followup" },
    { template: "clinical_portal_request_for_feedback_en" },
  ],
  //fr: Not yet supported
  nd: [
    { template: "chat_ready_vimbai_nd" },
    { template: "nurse_location_assistance_vimbai_nd" },
    { template: "flagged_support_checkin_vimbai_nd" },
    { template: "test_result_followup_vimbai_nd" },
    { template: "clinical_portal_request_for_feedback_nd" },
  ],
  sn: [
    { template: "chat_ready_vimbai_sn" },
    { template: "nurse_location_assistance_vimbai_sn" },
    { template: "flagged_support_checkin_vimbai_sn" },
    { template: "test_result_followup_vimbai_sn" },
    { template: "clinical_portal_request_for_feedback_sn" },
  ],
  //sw: Not yet supported
  zu: [
    { template: "chat_ready_zu" },
    { template: "nurse_location_assistance_zu" },
    { template: "flagged_support_checkin_zu" },
    { template: "test_result_followup_zu" },
    { template: "clinical_portal_request_for_feedback_zu" },
  ],
};

// This is used to map templates with language suffixes to the base template name
export const templateTitleOverrides: { [template: string]: string } = {
  chat_ready_vimbai_nd: "chat_ready",
  chat_ready_vimbai_sn: "chat_ready",
  chat_ready_zu: "chat_ready",
  nurse_location_assistance_vimbai_nd: "nurse_location_assistance_v3",
  nurse_location_assistance_vimbai_sn: "nurse_location_assistance_v3",
  nurse_location_assistance_zu: "nurse_location_assistance_v3",
  flagged_support_checkin_vimbai_nd: "flagged_support_checkin",
  flagged_support_checkin_vimbai_sn: "flagged_support_checkin",
  flagged_support_checkin_zu: "flagged_support_checkin",
  test_result_followup_vimbai_nd: "test_result_followup",
  test_result_followup_vimbai_sn: "test_result_followup",
  test_result_followup_zu: "test_result_followup",
  clinical_portal_request_for_feedback_en:
    "clinical_portal_request_for_feedback",
  clinical_portal_request_for_feedback_nd:
    "clinical_portal_request_for_feedback",
  clinical_portal_request_for_feedback_sn:
    "clinical_portal_request_for_feedback",
  clinical_portal_request_for_feedback_zu:
    "clinical_portal_request_for_feedback",
};
